export default __webpack_public_path__ + "3099800b2dcf37220beb10a756a68b30.png";